import "./App.css";

import WalletContextProvider from "./utils/WalletContextProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./page/Home";
import Layout from "./components/Layout";
import Layout2 from "./components/Layout2";
import CreatePublisher from "./page/CreatePublisher";
import ExplorePage from "./page/ExplorePage";
import AccountPage from "./page/AccountPage";
import RegisterAdCampaign from "./page/RegisterAdCampaign";
import ManagePendingAds from "./page/ManagePendingAds";
import ManageAdCampaign from "./page/ManageAdCampaign";
import BidAuction from "./page/BidAuction";
import IframeContent from "./components/IframeContent";
import { ProgramProvider } from "./utils/ProgramContext"
import ApplyForProviders from "./page/ApplyForProviders";
import ManageAuction from "./page/ManageAuction";
import LandingPage from "./page/LandingPage";
import AdvertiserInfo from './page/AdvertiserInfoPage';
import PublisherInfo from './page/PublisherInfoPage';
import MarketplaceInfo from './page/MarketplaceInfoPage';



const App = () => {

  return (
    <WalletContextProvider >
      <BrowserRouter>
        <ProgramProvider>
          <Routes>
            <Route path="/" element={<Layout2 />}>
              <Route index element={<LandingPage />} />
              <Route path="/advertiser" element={<AdvertiserInfo />} />
              <Route path="/publisher" element={<PublisherInfo />} />
              <Route path="/marketplace" element={<MarketplaceInfo />} />
            </Route>
            <Route path="/app/" element={<Layout />} >
              <Route index element={<Home />} />
              <Route path="/app/explore" element={<ExplorePage />} />
              <Route path="/app/account" element={<AccountPage />} />
              <Route path="/app/register-publisher" element={<CreatePublisher />} />
              <Route path="/app/manage-publisher" element={<ManagePendingAds />} />
              <Route path="/app/manage-publisher/:id" element={<ManageAuction />} />
              <Route path="/app/register-ad-campaign" element={<RegisterAdCampaign />} />
              <Route path="/app/manage-ad-campaign" element={<ManageAdCampaign />} />
              <Route path="/app/manage-ad-campaign/:id" element={<ApplyForProviders />} />
              <Route path="/app/auction/:id" element={<BidAuction />} />
            </Route>
            <Route path="/iframe-content/:providerPda" element={<IframeContent />} />
          </Routes>
        </ProgramProvider>
      </BrowserRouter>
    </WalletContextProvider>
  );
};

export default App;
